module.exports = __webpack_public_path__ + "img/filter-white.4bb547b3.svg";